export enum WorkShiftType {
    Regular = 'Regular',
    Vacation = 'Vacation',
}
